/**
 * Welle 120 — Suchen und Wählen in EINEM Feld: tippen, die Treffer stehen direkt darunter (gruppiert),
 * Auswahl per Klick oder ↑ ↓ Enter, Esc schließt. `laden(q)` liefert [{id, label, gruppe, art}] (async oder sofort).
 */
import React, { useEffect, useRef, useState } from "react";

export default function Suchfeld({ wert = "", placeholder = "", laden, onWahl, autoFocus = false, mitLeer = null }) {
  const [text, setText] = useState(wert);
  const [offen, setOffen] = useState(false);
  const [treffer, setTreffer] = useState([]);
  const [aktiv, setAktiv] = useState(0);
  const [laeuft, setLaeuft] = useState(false);
  const nr = useRef(0);
  const box = useRef(null);

  useEffect(() => { setText(wert); }, [wert]);

  useEffect(() => {
    if (!offen) return undefined;
    const meine = ++nr.current;
    const t = setTimeout(async () => {
      setLaeuft(true);
      try {
        const r = await laden(text.trim());
        if (meine === nr.current) { setTreffer((r || []).slice(0, 60)); setAktiv(0); }
      } catch (_) { if (meine === nr.current) setTreffer([]); }
      if (meine === nr.current) setLaeuft(false);
    }, 200);
    return () => clearTimeout(t);
  }, [text, offen, laden]);

  useEffect(() => {
    const zu = (e) => { if (box.current && !box.current.contains(e.target)) setOffen(false); };
    document.addEventListener("mousedown", zu);
    return () => document.removeEventListener("mousedown", zu);
  }, []);

  const liste = mitLeer ? [...treffer, mitLeer] : treffer;
  const waehlen = (t) => {
    setOffen(false);
    setText(t.label || "");
    onWahl(t);
  };
  const taste = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setOffen(true); setAktiv((a) => Math.min(a + 1, liste.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setAktiv((a) => Math.max(a - 1, 0)); }
    else if (e.key === "Enter") { if (offen && liste[aktiv]) { e.preventDefault(); waehlen(liste[aktiv]); } }
    else if (e.key === "Escape") setOffen(false);
  };

  let letzteGruppe = null;
  return (
    <div className="rg-such" ref={box}>
      <input className="mb-input" value={text} placeholder={placeholder} autoComplete="off" autoFocus={autoFocus}
        onFocus={(e) => { setOffen(true); e.target.select(); }}
        onChange={(e) => { setText(e.target.value); setOffen(true); }} onKeyDown={taste} />
      {offen && (liste.length > 0 || laeuft) && (
        <div className="rg-such-liste" role="listbox">
          {laeuft && !treffer.length && <div className="rg-such-leer">sucht …</div>}
          {liste.map((t, i) => {
            const kopf = t.gruppe && t.gruppe !== letzteGruppe ? t.gruppe : null;
            letzteGruppe = t.gruppe || letzteGruppe;
            return (
              <React.Fragment key={`${t.art || ""}:${t.id}:${i}`}>
                {kopf && <div className="rg-such-gruppe">{kopf}</div>}
                <button type="button" className={`rg-such-treffer${i === aktiv ? " aktiv" : ""}`}
                  onMouseEnter={() => setAktiv(i)} onMouseDown={(e) => { e.preventDefault(); waehlen(t); }}>{t.label}</button>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}
